module.exports = __webpack_public_path__ + "static/case-slide-3-eaccc3b9213ebf5786dddd33ce298834.jpg";